import {config} from '../config';

export default {
    getIsPwaEnabled: () => config.data.pwa?.isPwaEnabled,
    getIsPwaDesktopEnabled: () => config.data.pwa?.isPwaDesktopEnabled,
    getIsWebAppJourneyDisabled: () => config.data.pwa?.isWebAppJourneyDisabled,
};
